/**
 * Cấp độ lưu dữ liệu form tham số mới nhất
 */
export default {
  // Theo chứng từ
  Voucher: 0,
  // Theo loại chứng từ
  ReportId: 1,
  // Theo form
  Form: 2,
  //Form convert
  Convert: 3
}